import { z } from 'zod';

export const productItemSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  active_ingredients: z.array(z.string()).optional()
});

export const productsByCategorySchema = z.record(z.string(), z.array(productItemSchema));

export const drawerProductSchema = z.object({
  id: z.string(),
  name: z.string(),
  short_description: z.string().optional()
});

export const categoryWithProductsSchema = z.object({
  id: z.string(),
  name: z.string(),
  phenomena: z.array(drawerProductSchema) // Using 'phenomena' for compatibility with existing component
});

export const getCategoryWithProductsResponseSchema = z.array(categoryWithProductsSchema);

export type ProductItem = z.infer<typeof productItemSchema>;
export type ProductsByCategory = z.infer<typeof productsByCategorySchema>;
export type DrawerProduct = z.infer<typeof drawerProductSchema>;
export type CategoryWithProducts = z.infer<typeof categoryWithProductsSchema>;
export type GetCategoryWithProductsResponse = z.infer<typeof getCategoryWithProductsResponseSchema>;
